import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const BotonesMovilesPortal = ({ children, mostrar }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Solo mostrar si es móvil y la condición externa también lo permite
  if (!mostrar || !isMobile) {
    return null;
  }

  const portalStyles = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'var(--bg-white, #ffffff)',
    boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
    padding: '10px',
    zIndex: 999999,
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    gap: '5px',
    width: '100%',
    boxSizing: 'border-box'
  };

  return ReactDOM.createPortal(
    <div style={portalStyles}>
      {children}
    </div>,
    document.body
  );
};

export default BotonesMovilesPortal; 